import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  title: 'General values',
  fields: [
    {
      attributeName: 'name',
      helpText: 'Name of the user',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Name...',
    },
    {
      attributeName: 'mapId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Map icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'mapBKId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Map Background icon',
      helpText: 'Map background icon.',
      placeholder: 'Map background icon...',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'mapMobileId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Map icon',
      helpText: 'Mobile Map icon.',
      placeholder: 'Mobile Map icon...',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'mapMobileBKId',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Background Map icon',
      helpText: 'Mobile Background Map icon.',
      placeholder: 'Mobile Background Map icon...',
      fileType: ['image/*'],
      className:'col-sm-6',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'iconFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Flat icon',
      helpText: 'Flat icon.',
      placeholder: 'Flat icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'highlightFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Flat highlighted icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'selectedFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Flat selected icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mobileIconFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Flat icon',
      helpText: 'Mobile Flat icon.',
      placeholder: 'flat icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'mobileSelectedFlat',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile Flat selected icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sepflat",
      type:FormInputTypes.SEPARATOR
    },


    {
      attributeName: 'icon180',
      type: FormInputTypes.DOWNLOADABLE,
      label: '180 icon',
      helpText: '180 icon.',
      placeholder: '180 icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'highlight180',
      type: FormInputTypes.DOWNLOADABLE,
      label: '180 highlighted icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'selected180',
      type: FormInputTypes.DOWNLOADABLE,
      label: '180 selected icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mobileIcon180',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 180 icon',
      helpText: 'Mobile 180 icon.',
      placeholder: '180 icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'mobileSelected180',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 180 selected icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'icon360',
      type: FormInputTypes.DOWNLOADABLE,
      label: '360 icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'highlight360',
      type: FormInputTypes.DOWNLOADABLE,
      label: '360 highlighted icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'selected360',
      type: FormInputTypes.DOWNLOADABLE,
      label: '360 selected icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'mobileIcon360',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 360 icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName: 'mobileSelected360',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Mobile 360 selected icon',
      helpText: 'Map icon.',
      placeholder: 'Map icon...',
      fileType: ['image/*'],
      className:'col-sm-4',
      canUpdate:false,
      hasSelect:false
    },
    {
      attributeName:"sep5",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'isDefault',
      label: 'Is Default',
      helpText: 'Default images.',
      default: false,
      type: FormInputTypes.CHECKBOX,
      confirmPopup:true,
      confirmText:"Are you sure you want to change the isDefault value?. All lives are going to have this icons by default. Although it will be possible to chang them"
    },

  ],
};
